import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import enJSON from './locale/en.json'
import alJSON from './locale/al.json'

export const LANGUAGE_STORAGE_KEY = 'nuto_language';
export const DEFAULT_LANGUAGE = 'al';

function getInitialLanguage() {
    try {
        const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
        return stored === 'al' || stored === 'en' ? stored : DEFAULT_LANGUAGE;
    } catch {
        // localStorage unavailable (e.g. private browsing) — fall back to default.
        return DEFAULT_LANGUAGE;
    }
}

i18n.use(initReactI18next).init({
    resources: {
        en: {...enJSON},
        al: {...alJSON}
    },
    lng: getInitialLanguage(),
    fallbackLng: DEFAULT_LANGUAGE,
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
